import { CIUDAD, CLIENTE } from "@pcgerente-node/pcg-comun/dist/DTOs"
import React, { useEffect, useState } from "react"
import style from "../../../styles/paged.module.css"
import ModalCrearAgencia from "../../helpers/Modals/ModalCrearAgencia"
import ModalVerAgencias from "../../helpers/Modals/ModalVerAgencias"



interface ChildProps {
    misDestinatario: CLIENTE[]
    ciudades: CIUDAD[]
}


const Paged: React.FC<ChildProps> = ({ misDestinatario, ciudades }) => {
    let pages: number[] = []; 
    useEffect(() => {
        if (misDestinatario.length) {
            current(1)
        }
    }, [misDestinatario])

  
    //Paginado
    //states
    const [actualPage, setActualPage] = useState(1);
    const contenidoPorPágina = 15;

    //función recorredora del paginado
    const current = (numberpage: number) => {
        setActualPage(numberpage);
    };

    if (misDestinatario.length > 0) {
        for (let i = 1; i <= Math.ceil(misDestinatario.length / contenidoPorPágina); i++) {
            pages.push(i);
        }
    }

    //logica de recorrido del páginado
    const slicedPaged = () => {
        if (actualPage <= 3) {
            const slice = pages.slice(0, 7);
            return slice;
        }
        if (actualPage > 3 && pages[actualPage + 3] !== undefined) {
            const slice = pages.slice(actualPage - 4, actualPage + 3);
            return slice;
        } else if (actualPage > 3 && pages[actualPage + 4] === undefined) {
            const slice = pages.slice(pages.length - 7, pages.length);
            return slice;
        }
        return [1]
    };

    //acá seleccionamos el contenido general en 15 y lo guardamos en un estado  
    const indexOfLastProduct = actualPage * contenidoPorPágina;
    const indexOfFirstProduct = indexOfLastProduct - contenidoPorPágina;
    const contenidoSliced = misDestinatario.slice(indexOfFirstProduct, indexOfLastProduct);

    useEffect(() =>{
        if(actualPage && actualPage !==1)
            window.scrollTo(0, document.body.scrollHeight)
    },[contenidoSliced])
    return (
        <>
                {misDestinatario.length ?
            <div className="table-responsive">
                    <table className="table mb-4 contextual-table">
                        <thead>
                            <tr className="table-primary">
                                <th className="text-center">cedula</th>
                                <th >Razon Social</th>
                                <th >Dirección</th>
                                <th >Telefono</th>
                                <th className="text-center">Agencias</th>
                            </tr>
                        </thead>
                        <tbody>
                            <>
                                {
                                    contenidoSliced.map((cliente, i) =>
                                        <tr className="table-warning" key={i}>
                                            <td className="text-center">{cliente.cedula}</td>
                                            <td>{cliente.razonSocial}</td>
                                            <td>{cliente.direccion}</td>
                                            <td>{cliente.telefono}</td>
                                            <td >
                                                <div className="d-flex justify-content-around">
                                                    <ModalVerAgencias cliente={cliente}/>
                                                    <div className="ml-2">
                                                        <ModalCrearAgencia cliente={cliente} ciudades={ciudades}/>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>) 
                                }
                            </>
                        </tbody>

                    </table>
            </div>
                    :
                    <div className="d-flex justify-content-center">
                        <span className="text-danger" style={{fontSize:"1.4rem"}}> No se encontraron registros</span>
                    </div>
                }
            {
                misDestinatario.length > 15 ?
                    <div className={style.container}>
                        <ul className={style.containerPages}>
                            <button id={style.btnHidden} className={`${style.button} ${(actualPage === 0 || actualPage === 1) ? style.hiddenButton : style.buttonHover}`} onClick={() => current(actualPage - 1)}>{'<'}</button>
                            {slicedPaged().map(page => {
                                if (page === actualPage) {
                                    return (
                                        <li onClick={() => current(page)} className={`${style.page} ${style.pageActual}`} key={page} > {page} </li>
                                    )
                                }
                                else return (
                                    <li onClick={() => current(page)} className={style.page} key={page}> {page} </li>
                                )
                            })}
                            <button id={style.btnHidden} className={`${style.button} ${(pages[pages.length - 1] <= 1 || actualPage === pages[pages.length - 1] || misDestinatario.length < 1) ? style.hiddenButton : style.buttonHover}`} onClick={() => current(actualPage + 1)}>{">"}</button>
                        </ul>
                    </div>
                    :
                    <></>
            }
        </>
    )
}



export default Paged